import React, { Component } from 'react';
import { withRouter } from 'react-router';
import { firebaseRef } from '../firebase.js';
import FaClose from 'react-icons/lib/fa/close';
import Modal from 'react-modal';
Modal.setAppElement('#root');
var timer;
class Inputmain extends Component {
  constructor(props){
    super(props);
    this.state = {
      click: false,
      count: 0,
      timer: false,
      modal: false,
      withB: 0,
      withE: 0,
      withLM: 0,
      withUM: 0,
      withSL: 0,
    };
    this.doubleClick = this.doubleClick.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.count = this.count.bind(this);
    //this.componentDidMount = this.componentDidMount.bind(this);
  }

  count(event){
    var that=this;
    clearTimeout(timer);
    if (!this.state.click) {
    this.setState({ click: true });
    this.props.click(event);
     timer = setTimeout(function(){
        that.setState({ timer: true });
    },500)
  }else{
    if (this.state.timer) {
      this.setState({ click: false, timer: false });
      timer = null;
      this.props.click(event);
    }else{
      this.setState({ modal: true, click: false, timer: false });
      timer = null;
      this.props.click(event);
    }
  }
}

doubleClick(){
  this.setState({ modal:true });
}

  closeModal(){
    this.setState({ modal: false });
  }


  componentDidMount(){
    var that=this;
    var userId = this.props.match.params.user;
    var doctor = this.props.match.params.doctor;
    var refMain = firebaseRef.database().ref('doctors/'+doctor+'/users/'+userId+'/buttons');
    refMain.on('child_added', function(datasnapShot){
      var orderVal = datasnapShot.val().order;
      var value = datasnapShot.val().main;
      var afterValue = datasnapShot.val().mainAfter;
      var patt = new RegExp(that.props.group);
      if (patt.test(value)) {
        var times = ++that.state.count;
          that.setState({ count: times });
      }
      if (patt.test(afterValue)) {
        var times = ++that.state.count;
          that.setState({ count: times });
      }
      if (patt.test(value) && orderVal.includes("B")) {
        that.setState({ withB: ++that.state.withB });
      }
      if (patt.test(value) && orderVal.includes("E")) {
        that.setState({ withE: ++that.state.withE });
      }
      if (patt.test(value) && orderVal.includes("LM")) {
        that.setState({ withLM: ++that.state.withLM });
      }
      if (patt.test(value) && orderVal.includes("UM")) {
        that.setState({ withUM: ++that.state.withUM });
      }
      if (patt.test(value) && orderVal.includes("SL")) {
        that.setState({ withSL: ++that.state.withSL });
      }
    });
    refMain.on('child_removed', function(datasnapShot) {
      var value = datasnapShot.val().main;
      var orderVal = datasnapShot.val().order;
      var afterValue = datasnapShot.val().mainAfter;
      var patt = new RegExp(that.props.group);
      if (patt.test(value)) {
          that.setState({ count: --that.state.count });
      }
      if (patt.test(afterValue)) {
          that.setState({ count: --that.state.count });
      }
      if (patt.test(value) && orderVal.includes("B")) {
        that.setState({ withB: --that.state.withB });
      }
      if (patt.test(value) && orderVal.includes("E")) {
        that.setState({ withE: --that.state.withE });
      }
      if (patt.test(value) && orderVal.includes("LM")) {
        that.setState({ withLM: --that.state.withLM });
      }
      if (patt.test(value) && orderVal.includes("UM")) {
        that.setState({ withUM: --that.state.withUM });
      }
      if (patt.test(value) && orderVal.includes("SL")) {
        that.setState({ withSL: --that.state.withSL });
      }
    });
  }


  render() {
    const {group, check, title, special} = this.props;
    return (
        <div className={special ? 'highlight' : ''}>
          <label htmlFor={group} className={`main-buttons-label ${check.indexOf(group) > -1 ? 'label-click': ''}`}>{this.state.count}</label>
          <input type="checkbox" name={group} value={group} className="user-inputs user-inputs-radio" id={group} onClick={this.count} />
          <Modal
          isOpen={this.state.modal}
          onRequestClose={this.closeModal}
          className="Modal"
          contentLabel="Example Modal"
          >
          <div>
            <button type="button" style={{borderColor: 'transparent', padding: 20}} onClick={() => this.setState({ modal:false })}><FaClose /></button>
          </div>
          <div className="login-signup-container" align="center">
            <div className="flex-divs"><h3>Statistics for {group}</h3></div>
            <p align="center">With B: {this.state.withB}</p>
            <p align="center">With E: {this.state.withE}</p>
            <p align="center">With LM: {this.state.withLM}</p>
            <p align="center">With UM: {this.state.withUM}</p>
            <p align="center">With SL: {this.state.withSL}</p>
            </div>
          </Modal>
        </div>
    );
  }
}

export default withRouter(Inputmain);



// WEBPACK FOOTER //
// ./src/routes/Paitent/Inputmain.js